<template>
  <mf-loading-dialog :loading="$apollo.queries.cards.loading">
    <base-page-layout title="Histórico de pedidos">
      <v-card>
        <v-card-text>
          <v-data-table :headers="headers" :items="cards" sort-desc sort-by="purchase.timestamp">
            <template v-slot:item="{ item }">
              <tr class="cursor-pointer" @click="openDetails(item)">
                <td class="link-style">{{ item.user.name }}</td>
                <td>{{ DateTime.fromISO(item.updated_at).toFormat('dd/MM/yyyy | HH:mm') }}</td>
                <td>{{ DateTime.fromISO(item.purchase.timestamp).toFormat('dd/MM/yyyy | HH:mm') }}</td>
                <td>{{ item.agent }}</td>
                <td>{{ item.unit ? item.unit.name : '-' }}</td>
                <td>{{ item.purchase.delivery_method | type }}</td>
                <td>
                  <mf-icon fill small class="mb-1" :color="item.status === 'CONCLUDED' ? 'marca-0-l40' : 'vermelho-0'">fiber_manual_record</mf-icon>
                  <span class="ml-1">{{ item.status | status }}</span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <card-details v-if="detailsDialog && Object.keys(selectedCard).length" v-model="detailsDialog" :info.sync="selectedCard" />
    </base-page-layout>
  </mf-loading-dialog>
</template>

<script>
import { QUERY_KANBAN_CARDS_HISTORY } from '../../graphql'
import { DateTime } from 'luxon'

export default {
  components: {
    BasePageLayout: () => import('@/components/BasePageLayout.vue'),
    CardDetails: () => import('@/modules/pedidos/controle-pedidos/views/pages/ControlePedidosCardDetails.vue'),
  },
  filters: {
    type(value) {
      if (value === 'PICKUP') return 'Retirada'
      else return 'Entrega'
    },
    status(value) {
      switch (value) {
        case 'CONCLUDED':
          return 'Concluído'
        case 'CANCELED':
          return 'Cancelado'
      }
    },
  },
  data: () => ({
    cards: [],
    detailsDialog: false,
    selectedCard: {},
    DateTime: DateTime,
  }),
  computed: {
    headers() {
      return [
        {
          text: 'Nome do cliente',
          value: 'user.name',
          width: '20%',
        },
        {
          text: 'Última atualização',
          value: 'updated_at',
          width: '15%',
        },
        {
          text: 'Data e hora do pedido',
          value: 'purchase.timestamp',
          width: '15%',
        },
        {
          text: 'Responsável',
          value: 'agent',
          width: '15%',
        },
        {
          text: 'Loja',
          value: 'unit.name',
          width: '15%',
        },
        {
          text: 'Tipo do pedido',
          value: 'purchase.delivery_method',
          width: '10%',
        },
        {
          text: 'Status final',
          value: 'status',
          width: '10%',
        },
      ]
    },
  },
  apollo: {
    cards: {
      query: QUERY_KANBAN_CARDS_HISTORY,
      update({ kanbanCards }) {
        return kanbanCards
      },
      fetchPolicy: 'no-cache',
    },
  },
  methods: {
    openDetails(value) {
      this.selectedCard = value
      this.$nextTick(() => {
        this.detailsDialog = true
      })
    },
  },
}
</script>

<style lang="scss">
.link-style {
  color: $marca-0;
  text-decoration: underline;
}
</style>
